import { render, staticRenderFns } from "./RecommenderList.vue?vue&type=template&id=126c0bc2&"
import script from "./RecommenderList.vue?vue&type=script&lang=js&"
export * from "./RecommenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports